import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  AboutComponent,
  ContactComponent,
  HomeComponent,
  NotFoundComponent,
  SolutionsComponent
} from './pages';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: HomeComponent, data: { state: 'home' } },
  { path: 'solutions', component: SolutionsComponent, data: { state: 'solutions' } },
  { path: 'about', component: AboutComponent, data: { state: 'about' } },
  { path: 'contact', component: ContactComponent, data: { state: 'contact' } },
  { path: '**', component: NotFoundComponent, data: { state: 'notfound' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
